import { motion } from 'framer-motion';
import { heroEnter } from '../../utils/animations';

const wrapperStyle = { paddingBottom: '56.25%', height: 0 };
const iframeStyle = { position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' };

export function HeroVideo() {
    return (
        <motion.div
            {...heroEnter(0.2)}
            className="relative max-w-6xl mx-auto px-6 lg:px-12 pb-16"
            data-testid="hero-video"
        >
            <div className="relative rounded-sm overflow-hidden shadow-[0_32px_80px_rgba(0,0,0,0.5)] border border-white/10" style={wrapperStyle}>
                <iframe
                    src="https://player.vimeo.com/video/1179397369?h=8034ec063c&badge=0&autopause=0&player_id=0&app_id=58479"
                    style={iframeStyle}
                    frameBorder="0"
                    allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    title="Industry Leading VA's from White Glove Hiring"
                />
            </div>
        </motion.div>
    );
}
